import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/custom-opening-button/custom-opening-button.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
